import styled from "styled-components";
import { fontNormal } from "@tvg/atomic-ui/_static/Typography";

export const FreePastPerformanceWrapper = styled.div<{
  isMobile: boolean;
  isLegView?: boolean;
}>`
  width: 100%;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colorTokens.content.onDark};
  margin-top: 0 !important;
  ${({ isMobile, isLegView }) =>
    isMobile && !isLegView && "margin-bottom: 12px;"}
  font-family: ${fontNormal};
  ${({ isMobile, theme }) =>
    isMobile &&
    `border-top: 1px solid  ${theme.colorTokens.border.default};
    border-bottom: 1px solid ${theme.colorTokens.border.default};`}
`;

export const Title = styled.span`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 12px;
`;

export const PastPerformanceLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const TitleContainer = styled.div`
  font-size: 14px;
  justify-content: flex-end;
  font-weight: 500;
  line-height: 125%;
  ${({ theme }) => `color: ${theme.colorTokens.content.default}`};
`;

export const DocumentFormat = styled.span`
  margin-left: 6px;
  font-size: 10px;
  font-weight: normal;
  ${({ theme }) => `color: ${theme.colorTokens.content.neutral}`};
`;

export const DownloadLink = styled.div`
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  ${({ theme }) =>
    `color: ${theme.colorTokens.component.button.secondary.background.base}`};
  padding: 4px 8px;
  height: 25px;
  justify-content: center;
  align-items: center;
  line-height: 17px;
`;
